import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Swag = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      d="M9 4a1 1 0 0 0-2 0v10H5v-3a1 1 0 1 0-2 0v3.66c0 2.39 1.67 4.423 4 5.176V23H5v-2c-2.391-1.266-4-3.631-4-6.34V11a3 3 0 0 1 4-2.83V4a3 3 0 0 1 6 0v1.17c.313-.11.65-.17 1-.17.768 0 1.47.289 2 .764A2.989 2.989 0 0 1 16 5c.35 0 .687.06 1 .17V4a3 3 0 1 1 6 0v10.66c0 2.709-1.609 5.074-4 6.34v2h-2v-3.164c2.33-.753 4-2.786 4-5.176V4a1 1 0 1 0-2 0v9h-2V8a1 1 0 1 0-2 0v5h-2V8a1 1 0 1 0-2 0v5H9V4Z"
      fill="currentColor"
    />
  </Icon>
));

export default Swag;
